const diaCurto = (d: string) => `${d.slice(8, 10)}/${d.slice(5, 7)}`;
const MES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

/**
 * Período longo não cabe dia a dia: até 62 dias mostra cada dia; até 184, por SEMANA (blocos de 7
 * dias a partir do início); acima disso, por MÊS. O período anterior é agrupado igual (por posição),
 * para a comparação seguir justa. Ticket = faturamento ÷ cupons do bloco (não média de médias).
 */
export type Bloco = {
  rotulo: string;
  dias: readonly string[];
  faturamento: number;
  cupons: number;
  itens: number;
  ticket: number | null;
};
export function agrupar(
  dias: readonly { dia: string; faturamento: number; cupons: number; itens: number }[],
): Bloco[] {
  const modo = dias.length <= 62 ? 'dia' : dias.length <= 184 ? 'semana' : 'mes';
  const grupos = new Map<
    string,
    { rotulo: string; dias: string[]; faturamento: number; cupons: number; itens: number }
  >();
  dias.forEach((x, i) => {
    const k =
      modo === 'dia' ? x.dia : modo === 'semana' ? String(Math.floor(i / 7)) : x.dia.slice(0, 7);
    const rotulo =
      modo === 'dia'
        ? diaCurto(x.dia)
        : modo === 'semana'
          ? `sem. ${diaCurto(x.dia)}`
          : `${MES[Number(x.dia.slice(5, 7)) - 1] ?? ''}/${x.dia.slice(2, 4)}`;
    const g = grupos.get(k) ?? { rotulo, dias: [], faturamento: 0, cupons: 0, itens: 0 };
    g.dias.push(x.dia);
    g.faturamento += x.faturamento;
    g.cupons += x.cupons;
    g.itens += x.itens;
    grupos.set(k, g);
  });
  // bloco incompleto (semana com menos de 7 dias, mês que ainda não fechou) é marcado: a queda dele
  // não é queda de venda, é dia que falta
  const cheio = (g: { dias: string[] }) => {
    if (modo === 'dia') return true;
    if (modo === 'semana') return g.dias.length === 7;
    const [a = 0, m = 1] = (g.dias[0] ?? '').split('-').map(Number);
    return g.dias.length === new Date(Date.UTC(a, m, 0)).getUTCDate();
  };
  return [...grupos.values()].map((g) => ({
    ...g,
    rotulo: cheio(g) ? g.rotulo : `${g.rotulo} (parcial)`,
    faturamento: Math.round(g.faturamento * 100) / 100,
    ticket: g.cupons ? Math.round((g.faturamento / g.cupons) * 100) / 100 : null,
  }));
}
